import React from "react";
import { ForgetPasswordPage } from "../Components/UserAuthPages/ForgetPasswordPage";
export const ForgotPw = () => {
  return <ForgetPasswordPage />;
};
